import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bell, RefreshCw, Smartphone } from 'lucide-react';
import AppVersionControlSection from '../../components/MasterAdmin/AppVersionControlSection';
import { APP_VERSION_LABELS, AppKey } from '../../services/MasterAdmin/appConfigService';

const AppVersionControlPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<AppKey>('user');

  const handleRefresh = () => {
    window.location.reload();
  };

  const tabClass = (tab: AppKey) =>
    `px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
      activeTab === tab
        ? 'border-primary-600 text-primary-600 dark:border-primary-400 dark:text-primary-400'
        : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
    }`;

  return (
    <div className="w-full min-w-0 space-y-6">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
        <div className="max-w-3xl space-y-2">
          <div className="inline-flex items-center gap-2 text-xs font-medium text-primary-700 dark:text-primary-300 bg-primary-50 dark:bg-primary-900/30 px-2.5 py-1 rounded-full">
            <Smartphone className="w-3.5 h-3.5" />
            Per-platform version control
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Set Android (Play versionCode) and iOS (App Store build) separately for the User App and
            Service Provider App. Force update only after that platform’s build is live. Notifications
            go to user devices for Vedika.Health and vendor devices for Vedika.Health Plus.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link
            to="/app-version-control/notifications"
            className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            <Bell className="w-4 h-4" />
            Notification history
          </Link>
          <button
            type="button"
            onClick={handleRefresh}
            className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            <RefreshCw className="w-4 h-4" />
            Refresh
          </button>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden">
        <div className="flex border-b border-gray-200 dark:border-gray-700 overflow-x-auto">
          <button type="button" onClick={() => setActiveTab('user')} className={tabClass('user')}>
            {APP_VERSION_LABELS.user}
          </button>
          <button type="button" onClick={() => setActiveTab('plus')} className={tabClass('plus')}>
            {APP_VERSION_LABELS.plus}
          </button>
        </div>

        <AppVersionControlSection key={activeTab} appKey={activeTab} embedded={true} />
      </div>
    </div>
  );
};

export default AppVersionControlPage;
